import { IGameUser } from '../../../../../types/ApiTypes';

// T024: points/teamName/email live under `userGame`, so MUI DataGrid needs an
// explicit value (the bare field name resolves to undefined → sort is a no-op).
// Extracted as pure functions so the sort-by-value logic is regression-tested directly.
export const getPlayerPoints = (gameUser: IGameUser) => gameUser.userGame.points;

export const getPlayerTeamName = (gameUser: IGameUser) => gameUser.userGame.teamName;

export const getPlayerEmail = (gameUser: IGameUser) => gameUser.userGame.user?.email ?? '';
